<div class="companies-for-you">
  <!-- Hero -->
  <div class="companies-for-you__hero">
    <div class="vacancy-hero">
      <h1 class="vacancy-hero__title">{{ 'companies.for_you.hero_title' | translate }}</h1>
      <p class="vacancy-hero__subtitle">{{ 'companies.for_you.hero_subtitle' | translate }}</p>
    </div>
  </div>

  <!-- Search bar -->
  <div class="companies-for-you__search-bar">
    <div class="vacancy-container">
      <div class="companies-for-you__search-inner">
        <div class="companies-for-you__search-field">
          <label class="companies-for-you__search-label">{{ 'shared.where' | translate }}</label>
          <input
            type="text"
            [(ngModel)]="locationSearch"
            class="companies-for-you__search-input"
          />
        </div>
        <lib-single-select-search
          class="companies-for-you__distance-select"
          [options]="distanceOptions"
          [control]="distanceControl"
          [placeholder]="'10 km'"
          [myFloatLabel]="'never'"
          [forceControl]="true"
          [setControlValue]="true"
          [forceControlByOptions]="true"
          [disabledTyping]="true"
          [disableSearchOptionFiltering]="true"
          (changed)="onDistanceSelected($event)"
        ></lib-single-select-search>
        <button class="companies-for-you__search-btn">{{ 'shared.to_search' | translate }}</button>
      </div>
    </div>
  </div>

  <!-- Filters + Grid -->
  <div class="vacancy-container companies-for-you__content">
    <div class="vacancy-filters">
      <div>
        <label class="vacancy-filters__label">{{ 'companies.for_you.filter_fields' | translate }}</label>
        <lib-single-select-search
          class="vacancy-filters__select"
          [options]="fieldsOptions"
          [control]="fieldsControl"
          [placeholder]="'companies.for_you.filter_all_fields' | translate"
          [myFloatLabel]="'never'"
          [forceControl]="true"
          [setControlValue]="true"
          [forceControlByOptions]="true"
          [disabledTyping]="true"
          [disableSearchOptionFiltering]="true"
          (changed)="onFieldsSelected($event)"
        ></lib-single-select-search>
      </div>
      <div>
        <label class="vacancy-filters__label">{{ 'companies.for_you.filter_sectors' | translate }}</label>
        <lib-single-select-search
          class="vacancy-filters__select"
          [options]="sectorsOptions"
          [control]="sectorsControl"
          [placeholder]="'companies.for_you.filter_all_sectors' | translate"
          [myFloatLabel]="'never'"
          [forceControl]="true"
          [setControlValue]="true"
          [forceControlByOptions]="true"
          [disabledTyping]="true"
          [disableSearchOptionFiltering]="true"
          (changed)="onSectorsSelected($event)"
        ></lib-single-select-search>
      </div>
      <div>
        <label class="vacancy-filters__label">{{ 'companies.for_you.filter_languages' | translate }}</label>
        <lib-single-select-search
          class="vacancy-filters__select"
          [options]="languagesOptions"
          [control]="languagesControl"
          [placeholder]="'companies.for_you.filter_all_languages' | translate"
          [myFloatLabel]="'never'"
          [forceControl]="true"
          [setControlValue]="true"
          [forceControlByOptions]="true"
          [disabledTyping]="true"
          [disableSearchOptionFiltering]="true"
          (changed)="onLanguagesSelected($event)"
        ></lib-single-select-search>
      </div>
      <div>
        <label class="vacancy-filters__label">{{ 'companies.for_you.filter_employees' | translate }}</label>
        <lib-single-select-search
          class="vacancy-filters__select"
          [options]="employeesOptions"
          [control]="employeesControl"
          [placeholder]="'companies.for_you.filter_all_employees' | translate"
          [myFloatLabel]="'never'"
          [forceControl]="true"
          [setControlValue]="true"
          [forceControlByOptions]="true"
          [disabledTyping]="true"
          [disableSearchOptionFiltering]="true"
          (changed)="onEmployeesSelected($event)"
        ></lib-single-select-search>
      </div>
    </div>

    <div class="vacancy-grid">
      <bwc-company-card
        *ngFor="let company of visibleCompanies"
        [company]="company"
        [isFollowed]="isFollowed(company.id)"
        (followed)="toggleFollow($event)"
      ></bwc-company-card>
    </div>

    <div class="vacancy-load-more" *ngIf="hasMore">
      <button (click)="loadMore()">{{ 'shared.load_more' | translate }}</button>
    </div>
  </div>
</div>
